import React from 'react';
import { Url } from '@repo/types/Types';
import { buttonVariants } from '../../ui/button';
import { cn } from '../../lib/utils';

export type ButtonLinkProps = React.ButtonHTMLAttributes<HTMLAnchorElement> & {
  as?: React.ElementType;
  href: Url;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'outlined' | 'danger' | 'danger-secondary';
  size?: 'sm' | 'md' | 'lg';
  icon?: string;
};

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ as: Component = 'a', href, className = '', variant = 'primary', size = 'md', icon, children, ...props }, ref) => {
    const linkProps = Component === 'a' ? { href } : { to: href };
    return (
      <Component
        {...linkProps}
        ref={ref}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      >
        <div className="flex items-center gap-2 capitalize">
          {icon ? <span className="no-underline material-symbols-outlined">{icon}</span> : null}
          <p className="flex items-center gap-1">{children}</p>
        </div>
      </Component>
    );
  }
);

ButtonLink.displayName = 'ButtonLink';
